<template>
  <div class="share-top-container u-center mt-4">
    <ArticleFavorite :article="article" />
    <ScrollToComments :article="article" />
    <OButton class="u-center border rounded-3xl border-[#E2E5ED] text-sm font-medium text-primary-200 py-2 px-4" pure @click="openMenu">
      <OIcon icon="article/share" class="mr-1"></OIcon>
      <span>{{ $t('main.share') }}</span>
    </OButton>

    <div class="share-menu fixed top-0 left-0 z-full-page-loading w-full h-full flex invisible opacity-0" :class="{ active: isActive }">
      <div class="memu__overlay bg-black-50 fixed w-full h-full top-0 left-0 right-0 bottom-0" @click="closeMenu"></div>
      <div class="share-menu--wrapper relative bg-white w-full mt-auto mx-auto p-4 pt-8 rounded-lg space-y-4">
        <div class="absolute u-center top-1 right-1 w-10 h-10" @click="closeMenu">
          <OIcon icon="times-light" />
        </div>
        <OLink
          pure
          class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2"
          :href="`http://www.facebook.com/sharer/sharer.php?u=${articleUrl}`"
          @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Fbshare')"
        >
          <OIcon icon="article/facebook" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5 text-[#4363A2]" />
          {{ $t('share-button.fb-share') }}
        </OLink>
        <OLink
          pure
          class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2"
          :href="`https://twitter.com/intent/tweet?via=${TWITTER_USERNAME}&url=${articleUrl}&text=${article.title}`"
          @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Twittershare')"
        >
          <OIcon icon="article/twitter" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5" />
          {{ $t('share-button.tw-share') }}
        </OLink>
        <OLink
          pure
          class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2"
          :href="`whatsapp://send?text=${article.title} ${articleUrl}`"
          @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Whatsappshare')"
        >
          <OIcon icon="article/whatsapp" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5 text-[#25D366]" />
          {{ $t('share-button.wp-share') }}
        </OLink>
        <OLink
          pure
          class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2"
          :href="`https://t.me/share/url?url=${articleUrl}&text=${article.title}`"
          @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Telegramshare')"
        >
          <OIcon icon="article/telegram" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5 text-[#2EA2D8]" />
          {{ $t('share-button.tg-share') }}
        </OLink>
        <OLink
          pure
          class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2"
          href="https://news.google.com/publications/CAAqBwgKMIGmrAsw_rDEAw?ceid=TR:tr&oc=3&hl=tr&gl=TR"
          rel="noopener noreferrer nofollow"
          @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Googlenews')"
        >
          <OIcon icon="article/google" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5 text-[#4486F4]" />
          Google News
        </OLink>
        <OButton pure class="w-full flex items-center text-primary-100 text-sm font-medium px-4 py-2" @click="copyUrl()">
          <OIcon icon="article/link" svg-class="w-6 h-6 sm:w-[18px] sm:h-[18px] mr-2.5 text-primary-200" />
          {{ $t('share-button.copy-link') }}
        </OButton>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject, ref, onUnmounted, useContext, computed } from '@nuxtjs/composition-api';
import ArticleFavorite from './sticky/ArticleFavorite';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { eventBus } from '~/modules/common/utils/eventBus';
import { HOST_URL, TWITTER_USERNAME } from '~/constants/config';
import { useToast } from '~/composables/useModal';
import ScrollToComments from '~/modules/common/components/app/layout/ScrollToComments';
import { OButton, OLink, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: { ArticleFavorite, ScrollToComments, OButton, OLink, OIcon },
  setup() {
    const isActive = ref(false);
    const article = inject('article');
    const { i18n, $analyticsEvent } = useContext();
    const { sendDetayInteractionEvent } = onedioEvents();
    const { toastSuccess } = useToast();

    const openMenu = () => {
      sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Paylaş');
      lockScroll();
      isActive.value = true;
    };

    const closeMenu = () => {
      unlockScroll();
      isActive.value = false;
    };

    const articleUrl = computed(() => {
      return HOST_URL + getArticleUrl({ article });
    });

    const unlockScroll = () => document.getElementsByTagName('body')[0].classList.remove('no-scroll');
    const lockScroll = () => document.getElementsByTagName('body')[0].classList.add('no-scroll');

    const copyUrl = () => {
      const copy = require('copy-to-clipboard');
      $analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_copyURL');
      copy(HOST_URL + getArticleUrl({ article }));
      isActive.value = false;
      toastSuccess(i18n.t('main.copied'));
    };

    eventBus.on('close-comment-menu', closeMenu);
    onUnmounted(() => eventBus.off('close-comment-menu', closeMenu));

    return {
      article,
      isActive,
      openMenu,
      closeMenu,
      articleUrl,
      copyUrl,
      TWITTER_USERNAME,
    };
  },
});
</script>
<style lang="scss" scoped>
.share-menu {
  transition: all 0.3s ease;

  &.active {
    opacity: 1;
    visibility: visible;

    .share-menu--wrapper {
      transform: translateY(0);
    }
  }

  &--wrapper {
    transform: translateY(100%);
    will-change: transform;
    transition: all 0.6s ease;
    transition-delay: 0.2s;

    button,
    a {
      background-color: var(--bg-body-secondary);
      border-radius: 6px;
      height: 56px;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 428px) {
  .invisible {
    margin-left: 0 !important;
  }
}
</style>
